<template>
  <el-form :model="alibabaForm" ref="form" label-width="12%" v-loading="loading">
    <!-- <slot name="errMsg"></slot> -->
    <section>
      <div class="title ft-12">
        <span>类目选择</span>
      </div>
      <div class="conf">
        <el-form-item label="商品分类:" prop="categoryIds">
          <div class="category ft-12">
            <category-input
              ref="cinput"
              :isSupportAi="true"
              :categoryIds="alibabaForm['categoryIds']"
              :baseItemId="baseItemId"
              @change="categoryIdsChange"
              platform="alibaba"
            />
          </div>
        </el-form-item>
      </div>
    </section>

    <template v-if="formSections.length">
      <section v-for="(section, sectionIndex) in formSections" :key="sectionIndex">
        <div class="title ft-12" v-if="section.title">
          <span>{{ section.title }}</span>
        </div>
        <div class="conf">
          <!-- 在物流信息section中添加发货地址slot -->
          <slot v-if="section.title === '物流信息'" name="cbuSendAddress"></slot>
          <template v-for="field in section.children">
            <el-form-item
              v-if="field.isShowFn ? field.isShowFn(alibabaForm) : true"
              :key="field.name"
              :prop="field.propName || field.name"
              :label="formatLabel(field)"
              :rules="field.rules"
              :class="[noLabelStyles.includes(field.name) ? 'noLabel' : '']"
            >
              <UseCategoryTemplate :detailHasCategory="alibabaForm['detailHasCategory']" :detailId="alibabaForm['id']" :baseItemId="baseItemId" v-if="field.name =='catProp'" :categoryIds="alibabaForm['categoryIds']" platform="alibaba" :getPropValues="getPropValues" @clickFill="clickTemPlateFill">
                <component
                  :ref="field.name"
                  :is="field.component.component"
                  :props="field.component.props"
                  >
                </component>
              </UseCategoryTemplate>
              <template v-else>
                <div class="preText" v-if="field._preTextFn" v-html="field._preTextFn(alibabaForm)"></div>
                <component
                  :style="field.style"
                  :ref="field.name"
                  :is="field.component.component"
                  :props="field.component.props"
                  @fieldChanged="specificationsFieldChanged"
                  @file-upload="handleImageUpload"
                  :showAuditResult="showAuditResult"
                  :auditFileList="auditFileList"
                ></component>
                <div class="suffixText" v-if="field._suffixTextFn" v-html="field._suffixTextFn(alibabaForm)"></div>
                <div
                  v-else-if="
                    field.tipRule &&
                    field.tipRule.length &&
                    (field.isShowTipFn ? field.isShowTipFn(alibabaForm) : true) &&
                    !(field.name === 'saleProp' && removePureItem && alibabaForm.pureType)
                  "
                  class="tips ft-12"
                >
                  <span style="display: block" v-for="(tip, tipIndex) in field.tipRule" v-html="tip" :key="tipIndex"></span>
                </div>
              </template>
            </el-form-item>
          </template>
        </div>
      </section>
    </template>
    <slot name="shipShelf"></slot>
  </el-form>
</template>

<script>
import CategoryInput from '../../../PlatformCategoryInput/index.vue';
import UseCategoryTemplate from '../../../UseCategoryTemplate.vue'
import { formatDataForm, formatFormData} from '../../utils/data';
import { cloneDeep } from 'lodash'

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    CategoryInput,
    UseCategoryTemplate
  },
  props: {
    formSections: {
      type: Array,
      default: () => [],
    },
    auditFileList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    priceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showAuditResult: {
      type: Boolean,
      default: false,
    },
    baseItemId: [Number, String],
  },
  data() {
    return {
      loading: false,
      rules: {},
      noLabelNames: ['saleProp', 'globalStock', 'invoice', 'sellPromise', 'deliveryTimeSetBySku'],
      noLabelStyles: ['saleProp', 'globalStock'],
      shopList: [],
      shipsTemplate: {}, // 运费模板列表
      shipsValue: {}, // 运费模板值
      shelfState: 1,
      priceValue: '',
      showPriceTip: false,
      itemPropValues: []
    };
  },
  computed: {
    ...mapGetters(['alibabaForm', 'removePureItem']),
  },
  methods: {
    ...mapActions(['updateAlibabaForm']),
    // 类目更新后的回调
    categoryIdsChange(v) {
      this.updateAlibabaForm({
        categoryIds: v,
      });
      this.$emit('categoryChange', v);
    },

    formatLabel(field) {
      // 需要对部分字段特殊处理 KMERP-68827
      if (field.name === 'warranty') return '售后服务';
      if (field.name === 'alibabaDeliveryTime') return ' ';
      return this.noLabelNames.includes(field.name) ? '' : field.label;
    },
    specificationsFieldChanged() {
      this.$emit('fieldChanged');
    },
    handleImageUpload(v) {
      this.$emit('file-upload', v);
    },
    clickTemPlateFill(row) {
      const parsePlatformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : [];
      const catFormSection = cloneDeep(this.formSections).filter(section => section.title === "基础信息")
      catFormSection.forEach(item => {
        item.children = item.children.filter(childItem => childItem.name === "catProp")
      })
      const catForm = formatDataForm({ fieldDescriptorList: parsePlatformCatProp }, catFormSection);
      this.updateAlibabaForm(catForm);
    },
    getPropValues() {
      const fieldDescriptorList = formatFormData(this.alibabaForm, this.formSections)
      return fieldDescriptorList.filter(item => item && item.name === "catProp");
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.noLabel {
  & ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
  & ::v-deep .el-form-item__error,
  .tips {
    margin-left: 12% !important;
  }
}
.preText,
.suffixText {
  font-size: 12px;
  display: inline-block;
}
.preText {
  margin-right: 5px;
}
.suffixText {
  margin-left: 5px;
}
.fix-price-remind {
  color: #f56c6c;
  margin-right: 20px;
}
.get-low {
  margin-left: -10px;
}
</style>